import { Blueprint, InitType } from "../blueprint";
import { StateServices } from "../../instance-service/i-state-services";
import { Vector2, Vector3 } from "three";
import { RenderServices } from "../../instance-service/i-render-services";
import { CameraState } from "src/app/state/camera/camera.state";
import { Entity } from "src/app/state/entities/entity.model";
import { selectCameraState } from "src/app/state/camera/camera.selector";
import {NetworkServices} from "../../instance-service/i-network-services";
import {UserAvatarDrawable} from "./user-avatar.drawable";
import {IMetadata} from "../../instance-service/i-metadata";

import * as usersSelectors from "../../../../state/users/users.selector";

import {UsersActions} from "../../../../state/users/usersActions";
import {User} from "../../../../auth/primitives/user";
export class UserAvatarBlueprint extends Blueprint {
  override destroy(): void {
      throw new Error("Method not implemented.");
  }
  override id: string;
  override type: string = "UserAvatar"

  entity: Entity;
  camera: CameraState;

  stateServices: StateServices
  renderServices: RenderServices
  networkServices: NetworkServices

  avatarDrawable: UserAvatarDrawable;

  isOwners: boolean
  user: User

  async init(config: {
    entity: Entity, 
    initType: InitType, 
    stateServices: StateServices,
    renderServices: RenderServices,
    networkServices: NetworkServices,
    metadata: IMetadata
  }) {
    this.id = config.entity.id
    this.stateServices = config.stateServices
    this.renderServices = config.renderServices
    this.networkServices = config.networkServices
    const store = config.stateServices.store
    this.entity = config.entity;
    if (config.metadata.isOwners) {
      this.isOwners = true
      return
    }
    store.select(selectCameraState)
        .subscribe((cameraState) => {
      this.camera = cameraState;
    });
    store.select(selectCameraState)
        .subscribe((cameraState) => {
      this.camera = cameraState;
    });
    store.select(
        usersSelectors.selectUserById(this.entity.ownerId)
    ).subscribe(async (user) => {
      this.user = user
      await this.updateImage()
    })
    store.dispatch(
        UsersActions.subscribeToUser({userId: this.entity.ownerId})
    )
    this.id = config.entity.id;
    this.avatarDrawable = new UserAvatarDrawable()
    await this.avatarDrawable.init({
      stateServices: config.stateServices,
      networkServices: config.networkServices,
      threeService: this.renderServices.threeService,
      surfaceService: this.renderServices.surfaceService,
      location: this.entity.coord,
      userId: this.entity.ownerId
    })
    await this.updateImage()
  }

  async updateImage() {
    if (this.avatarDrawable && this.user) {
      await this.avatarDrawable.updateImage(
          this.user.profile_image_file_id
      )
    }
  }

  override updatePosition(config: { newPos: Vector3; }) {
    if (this.isOwners) {
      return
    }
    this.avatarDrawable.updatePosition(config.newPos)
  }

}
